<!--
  回单图片放大查看器
  替代 element-ui 的 <el-image-viewer>，原因是该组件内置 data().index=0，
  且没有读取 :initial-index prop，导致每次打开都展示 urlList[0] 而不是用户实际点击的图片。

  行为对齐 element-ui 体验：
  - 全屏遮罩 + 居中展示当前图片
  - 左右方向键 / 按钮切换；只有一张图时不显示箭头
  - ESC 关闭；点击遮罩关闭
  - :initial-index 真正生效：从用户点击的那张开始展示
  - 通过 :append-to-body 渲染到 body，避免被父级 dialog 的 z-index / overflow 影响
-->
<template>
  <transition name="receipt-viewer-fade">
    <div class="receipt-image-viewer__wrapper" :style="{ zIndex: zIndex }" @click.self="handleMaskClose">
      <div class="receipt-image-viewer__mask"></div>

      <span class="receipt-image-viewer__btn receipt-image-viewer__close" @click="close">
        <i class="el-icon-circle-close"></i>
      </span>

      <template v-if="!isSingle">
        <span
          class="receipt-image-viewer__btn receipt-image-viewer__prev"
          @click="prev">
          <i class="el-icon-arrow-left"/>
        </span>
        <span
          class="receipt-image-viewer__btn receipt-image-viewer__next"
          @click="next">
          <i class="el-icon-arrow-right"/>
        </span>
      </template>

      <div class="receipt-image-viewer__canvas">
        <img
          v-if="currentUrl"
          :key="currentUrl"
          ref="img"
          class="receipt-image-viewer__img"
          :src="currentUrl"
          :alt="`回单图片 ${index + 1}`"
          @load="handleImgLoad"
          @error="handleImgError">
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ReceiptImageViewer',
  props: {
    urlList: {
      type: Array,
      default: () => []
    },
    initialIndex: {
      type: Number,
      default: 0
    },
    zIndex: {
      type: Number,
      default: 9999
    },
    onClose: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      index: 0,
      loaded: false
    }
  },
  computed: {
    isSingle() {
      return this.urlList.length <= 1
    },
    currentUrl() {
      return this.urlList[this.index] || ''
    }
  },
  watch: {
    initialIndex: {
      immediate: true,
      handler(val) {
        if (typeof val === 'number' && val >= 0 && val < this.urlList.length) {
          this.index = val
        }
      }
    }
  },
  mounted() {
    document.addEventListener('keydown', this.onKeyDown)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyDown)
  },
  methods: {
    open() {
      // 父组件通过 v-if 控制挂载,此处仅作兼容保留
    },
    close() {
      this.onClose()
    },
    handleMaskClose() {
      this.close()
    },
    prev() {
      if (this.urlList.length === 0) return
      this.index = (this.index - 1 + this.urlList.length) % this.urlList.length
    },
    next() {
      if (this.urlList.length === 0) return
      this.index = (this.index + 1) % this.urlList.length
    },
    handleImgLoad() {
      this.loaded = true
    },
    handleImgError(e) {
      this.loaded = true
      if (e && e.target) {
        e.target.alt = '加载失败'
      }
    },
    onKeyDown(e) {
      if (e.keyCode === 27) { // ESC
        this.close()
      } else if (e.keyCode === 37) { // ←
        this.prev()
      } else if (e.keyCode === 39) { // →
        this.next()
      }
    }
  }
}
</script>

<style scoped>
.receipt-image-viewer__wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.receipt-image-viewer__mask {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
}
.receipt-image-viewer__btn {
  position: absolute;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  color: #fff;
  font-size: 28px;
  cursor: pointer;
  user-select: none;
}
.receipt-image-viewer__close {
  top: 24px;
  right: 24px;
}
.receipt-image-viewer__prev {
  top: 50%;
  left: 24px;
  transform: translateY(-50%);
}
.receipt-image-viewer__next {
  top: 50%;
  right: 24px;
  transform: translateY(-50%);
}
.receipt-image-viewer__canvas {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 80px;
  box-sizing: border-box;
}
.receipt-image-viewer__img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  background: #fff;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.4);
}

.receipt-viewer-fade-enter-active,
.receipt-viewer-fade-leave-active {
  transition: opacity 0.2s ease;
}
.receipt-viewer-fade-enter,
.receipt-viewer-fade-leave-to {
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/receipt-image-viewer.vue